import React from "react";
import { Modal } from "react-bootstrap";

import RPImgcreditPayment from "./RPImgcreditPayment";

export default class RPPaymentModal extends React.Component {
  componentDidMount() {}

  render() {
    const {
      no_of_imgcredits,
      subscription_id,
      subscription_status,
      sub_start_date,
      sub_end_date,
      uid
    } = this.props.fields;

    const convenienceCharges = 0.05;

    const gst = 0.18;

    if (subscription_status === "ACTIVE") {
      var startDate = new Date(sub_start_date);
      var endDate = new Date(sub_end_date);
    }

    return (
      <Modal
        centered="true"
        show={no_of_imgcredits > 0}
        onHide={(e) => {
          this.props.resetImgcredit();
        }}
        style={{ color: "Black" }}
      >
        <Modal.Header closeButton>
          <Modal.Title>Purchase Image Credits</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <ul style={{ listStyleType: "none" }}>
            <li>
              <strong>
                Price for {no_of_imgcredits} Image Credits: ₹
                {no_of_imgcredits * 45}
              </strong>
            </li>

            <li>
              <strong>
                Convenience Charges : ₹
                {parseFloat(
                  no_of_imgcredits * 45.0 * convenienceCharges
                ).toFixed(2)}
              </strong>
            </li>

            <li>
              <strong>
                GST 18% : ₹
                {parseFloat(
                  (no_of_imgcredits * 45 +
                    no_of_imgcredits * 45 * convenienceCharges) *
                    gst
                ).toFixed(2)}
              </strong>
            </li>

            <li>
              <strong>
                Grand Total: ₹{" "}
                {Math.round(
                  no_of_imgcredits * 45 +
                    no_of_imgcredits * 45 * convenienceCharges +
                    (no_of_imgcredits * 45 +
                      no_of_imgcredits * 45 * convenienceCharges) *
                      gst
                ).toFixed(2)}
              </strong>
            </li>
          </ul>

          <RPImgcreditPayment
            no_of_imgcredits={no_of_imgcredits}
            amount={Math.round(
              no_of_imgcredits * 45 +
                no_of_imgcredits * 45 * convenienceCharges +
                (no_of_imgcredits * 45 +
                  no_of_imgcredits * 45 * convenienceCharges) *
                  gst
            ).toFixed(2)}
            convenienceCharges={convenienceCharges}
            uid={uid}
          />
        </Modal.Body>
      </Modal>
    );
  }
}
